import { useLocation } from "react-router";

export function useSearchParams<
	T extends Record<string, string> = Record<string, string>
>() {
	const location = useLocation();

	const params = new URLSearchParams(location.search);

	return {
		...params,
		delete: (key: keyof T) => {
			params.delete(key as string);
		},
		has: (key: keyof T) => {
			return params.has(key as string);
		},
		get: <G extends keyof T>(key: G) => {
			return params.get(key as string) as T[G];
		},
		set: <G extends keyof T>(key: G, value: T[G]) => {
			params.set(key as string, value as string);
		},
		toURL: () => location.pathname + "?" + params.toString(),
	} as const;
}
